import Button from 'common/components/buttons/button';
import { ButtonTheme } from 'common/components/buttons/button-theme';
import { FC } from 'react';
import { CSVLink } from 'react-csv';

interface CSVExportButtonProps {
  headers: string[];
  rows: any[][];
  filename: string;
}

export const CSVExportButton: FC<CSVExportButtonProps> = ({
  headers,
  rows,
  filename
}) => {
  const allRowsForCsv = [headers, ...rows];

  return (
    <CSVLink data={allRowsForCsv} filename={filename}>
      <Button
        theme={ButtonTheme.CANCEL}
        identifier="export"
        onClick={() => null}
        isLoading={false}
      >
        <div className="flex items-center justify-between">
          <i className="ra-icons-generic-download text-sm mr-2 flex"></i>
          Export
        </div>
      </Button>
    </CSVLink>
  );
};

export default CSVExportButton;
